import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "customer-tasks-link mb-4 rounded-lg border border-border bg-card"
}
const _hoisted_2 = { class: "tasks-link-content" }
const _hoisted_3 = { class: "flex items-center gap-2 text-sm font-semibold" }
const _hoisted_4 = { class: "tasks-link-actions" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  role: "status",
  class: "copy-toast fixed bottom-5 left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-lg border border-border bg-card px-4 py-3 text-sm shadow-lg"
}
const _hoisted_7 = { class: "flex min-w-0 flex-col gap-2 text-sm" }

import { computed, onUnmounted, ref, watch } from 'vue';
import { ArrowUpRight, Check, Copy, ListTodo } from '@lucide/vue';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';


export default /*@__PURE__*/_defineComponent({
  __name: 'PropertyCustomerTasksLink',
  props: {
    tasks: {}
  },
  setup(__props: any) {

const props = __props;
const publicUrl = computed(() =>
  props.tasks.url ? new URL(props.tasks.url, window.location.origin).href : ''
);
const copied = ref(false);
const manualCopy = ref(false);
let copiedTimer: ReturnType<typeof setTimeout> | undefined;

async function copyLink() {
  if (!publicUrl.value) return;
  try {
    await navigator.clipboard.writeText(publicUrl.value);
    copied.value = true;
    clearTimeout(copiedTimer);
    copiedTimer = setTimeout(() => {
      copied.value = false;
    }, 3000);
  } catch {
    manualCopy.value = true;
  }
}
function selectLink(event: FocusEvent) {
  (event.target as HTMLInputElement).select();
}
watch(publicUrl, () => {
  clearTimeout(copiedTimer);
  copied.value = false;
  manualCopy.value = false;
});
onUnmounted(() => clearTimeout(copiedTimer));

return (_ctx: any,_cache: any) => {
  return (publicUrl.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, [
            _createVNode(_unref(ListTodo), {
              class: "size-4 text-muted-foreground",
              "aria-hidden": "true"
            }),
            _cache[1] || (_cache[1] = _createTextVNode("Задачи клиента ", -1))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Button), {
              "as-child": "",
              size: "sm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: publicUrl.value,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, [
                  _cache[2] || (_cache[2] = _createTextVNode("Открыть задачи", -1)),
                  _createVNode(_unref(ArrowUpRight), {
                    class: "ml-1.5 size-4",
                    "aria-hidden": "true"
                  })
                ], 8, _hoisted_5)
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              type: "button",
              variant: "outline",
              size: "sm",
              onClick: copyLink
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Copy), {
                  class: "mr-1.5 size-3.5",
                  "aria-hidden": "true"
                }),
                _cache[3] || (_cache[3] = _createTextVNode("Копировать ссылку", -1))
              ]),
              _: 1
            })
          ])
        ]),
        (copied.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(Check), {
                class: "size-4 shrink-0 text-emerald-600",
                "aria-hidden": "true"
              }),
              _cache[4] || (_cache[4] = _createTextVNode("Ссылка на задачи клиента скопирована ", -1))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(Dialog), {
          open: manualCopy.value,
          "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((manualCopy).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogContent), { class: "sm:max-w-xl" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogTitle), null, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("Ссылка на задачи клиента", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_unref(DialogDescription), null, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("Автоматическое копирование недоступно. Скопируйте ссылку из поля.", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("label", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-medium" }, "Ссылка для клиента", -1)),
                  _createVNode(_unref(Input), {
                    "model-value": publicUrl.value,
                    "aria-label": "Ссылка для клиента",
                    readonly: "",
                    autofocus: "",
                    onFocus: selectLink
                  }, null, 8, ["model-value"])
                ]),
                _createVNode(_unref(DialogFooter), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogClose), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Button), {
                          type: "button",
                          variant: "outline"
                        }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode("Закрыть", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["open"])
      ]))
    : _createCommentVNode("", true)
}
}

})